const Referral = () => (
  <>
    <p className="console-panel-desc">邀请好友注册，获得返利奖励。</p>
    <div className="console-grid-2">
      <div className="console-card">
        <div className="console-card-header">
          <h3 className="console-card-title">我的邀请码</h3>
        </div>
        <div className="console-card-body">
          <div className="console-status-value" style={{ fontSize: '1.5rem', letterSpacing: '0.1em' }}>
            LVCHUNLC
          </div>
          <button type="button" className="console-btn" style={{ marginTop: '1rem' }}>
            复制邀请链接
          </button>
        </div>
      </div>
      <div className="console-card">
        <div className="console-card-header">
          <h3 className="console-card-title">返利统计</h3>
        </div>
        <div className="console-card-body">
          <div className="console-status-grid">
            <div className="console-status-item">
              <div className="console-status-label">邀请人数</div>
              <div className="console-status-value">0</div>
            </div>
            <div className="console-status-item">
              <div className="console-status-label">待结算返利</div>
              <div className="console-status-value">¥0.00</div>
            </div>
            <div className="console-status-item">
              <div className="console-status-label">已结算返利</div>
              <div className="console-status-value">¥0.00</div>
            </div>
            <div className="console-status-item">
              <div className="console-status-label">返利比例</div>
              <div className="console-status-value">10%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default Referral;
